import {
  Book,
  CalendarCheck,
  CheckCircle,
  ClipboardList,
  Coins,
  CreditCard,
  House,
  LogOut,
  ShoppingCart,
  User,
  Users,
  ListChecksIcon,
  LayoutTemplate,
  MessageSquare,
  FlaskConical,
  Activity,
  Star,
} from "lucide-react";

export const sidebarMenuRoutes = {
  dashboard: { label: "Tableau de bord", to: "/dashboard", icon: House },
  categories: { label: "Catégories", to: "/categories", icon: ListChecksIcon },
  subscriptionsPlan: { label: "Subscription Plans", to: "/subscription-plans", icon: LayoutTemplate },
  paymentOptions: {
    label: "Paiements formateurs",
    to: "/payment-options",
    icon: CreditCard,
  },
  users: { label: "Utilisateurs", to: "/users", icon: Users },
  trainers: {
    label: "Formateurs",
    to: "/trainers",
    icon: User,
  },
  certification: {
    label: "Certification",
    to: "/certification-criteria",
    icon: CheckCircle,
  },
  certificationRequests: {
    label: "Demandes certification",
    to: "/certification-requests",
    icon: ClipboardList,
  },
  formations: { label: "Formations", to: "/formations", icon: Book },
  featuredFormations: { label: "Mise en avant", to: "/mise-en-avant", icon: Star },
  coaching: { label: "Coaching", to: "/coaching", icon: CalendarCheck },
  feedbacks: { label: "Feedbacks", to: "/feedbacks", icon: MessageSquare },
  coinAttributions: { label: "Attribution Coins", to: "/coin-attributions", icon: Coins },
  orders: { label: "Commandes", to: "/orders", icon: ShoppingCart },
  cockpit: { label: "Cockpit", to: "/cockpit", icon: Activity },
  stripeSubscriptionTest: {
    label: "Test abonnement Stripe",
    to: "/stripe-subscription-test",
    icon: FlaskConical,
  },
  // communautes: {
  //   label: "Communautés",
  //   to: "/communautes",
  //   icon: MessageSquare,
  // },
  // reviews: {
  //   label: "Avis et notes",
  //   to: "/reviews",
  //   icon: StarIcon,
  // },
  // pages: {
  //   label: "Pages statiques",
  //   to: "/pages",
  //   icon: FileText,
  // },
  // reports: { label: "Rapports", to: "/reports", icon: BarChart },
  // support: { label: "Support", to: "/support", icon: HelpCircle },
  // settings: { label: "Paramètres", to: "/settings", icon: Settings },
  logout: { label: "Deconnexion", to: "/logout", icon: LogOut },
};

const appRoutes = {
  protected: {
    dashboard: sidebarMenuRoutes.dashboard.to,
    dash: "/dash",
    users: "/users",
    trainers: "/trainers",
    createTrainer: "/trainers/create",
    certificationCriteria: "/certification-criteria",
    certificationRequests: "/certification-requests",
    certificationReviewQueue: "/certification-review-queue",
    formations: "/formations",
    featuredFormations: sidebarMenuRoutes.featuredFormations.to,
    coaching: sidebarMenuRoutes.coaching.to,
    coachingCancelled: "/coaching/annulations",
    coachingOfferBookings: {
      buildRoute: (offerId: number) => `/coaching/offres/${offerId}`,
      labelRoute: "/coaching/offres/:offerId",
    },
    feedbacks: "/feedbacks",
    coinAttributions: "/coin-attributions",
    orders: "/orders",
    cockpit: sidebarMenuRoutes.cockpit.to,
    stripeSubscriptionTest: "/stripe-subscription-test",
    paymentOptions: sidebarMenuRoutes.paymentOptions.to,
    communautes: "/communautes",
    reviews: "/reviews",
    categories: "/categories",
    addCategory: "/categories/add",
    subscriptionPlan: "/subscription-plans",
    addSubscriptionPlan: "/subscription-plans/add",
    pages: "/pages",
    reports: "/reports",
    addUser: "/users/add",
    userDetail: {
      buildRoute: (userId: number) => `/users/${userId}`,
      labelRoute: "/users/:userId",
    },
    categoryDetail: {
      buildRoute: (categoryId: number) => `/categories/${categoryId}`,
      labelRoute: "/categories/:categoryId",
    },
    subscriptionPlanDetail: {
      buildRoute: (id: number) => `/subscription-plans/${id}`,
      labelRoute: "/subscription-plans/:id",
    },
    userEdit: {
      buildRoute: (userId: number) => `/users/${userId}/edit`,
      labelRoute: "/users/:userId/edit",
    },
    userSuspend: {
      buildRoute: (userId: number) => `/users/${userId}/suspend`,
      labelRoute: "/users/:userId/suspend",
    },
    userDelete: "/users/:userId/delete",
    trainerPayments: {
      buildRoute: (userId: number) => `/users/${userId}/payments`,
      labelRoute: "/users/:userId/payments",
    },
    trainerApproval: {
      route: "/users/:userId/approval",
      buildRoute: (userId: number) => `/users/${userId}/approval`,
    },
    trainerReject: "/users/:userId/reject",
    assignSubscriptionPlan: {
      buildRoute: (userId: number) => `/trainers/${userId}/assign-plan`,
      labelRoute: "/trainers/:userId/assign-plan",
    },
    formationDetail: {
      buildRoute: (formationId: number) => `/formations/${formationId}`,
      labelRoute: "/formations/:formationId",
    },
    courseDetail: "/courses/:courseId",
  },
  public: {
    login: "/",
  },
  logout: sidebarMenuRoutes.logout.to,
};

export default appRoutes;